<template>
  <transition enter-active-class="tw-ease-out tw-duration-300" leave-active-class="tw-ease-in tw-duration-200">
    <div class="tw-fixed tw-inset-0 tw-overflow-hidden tw-z-30" v-show="isVisible">
      <div class="tw-absolute tw-inset-0 tw-overflow-hidden">
        <transition
          enter-active-class="tw-ease-in-out tw-duration-300"
          enter-class="tw-opacity-0"
          enter-to-class="tw-opacity-100"
          leave-active-class="tw-ease-in-out tw-duration-200"
          leave-class="tw-opacity-100"
          leave-to-class="tw-opacity-0"
        >
          <div v-show="isVisible" class="tw-fixed tw-inset-0 tw-transition-opacity tw-backdrop-blur tw-backdrop-filter" @click="isVisible = false">
            <div class="tw-absolute tw-inset-0 tw-bg-gray-700 tw-opacity-50"></div>
          </div>
        </transition>
        <section class="tw-absolute tw-inset-y-0 tw-right-0 tw-max-w-full tw-flex">
          <transition
            enter-active-class="tw-transform tw-transition tw-ease-in-out tw-duration-200 sm:tw-duration-300"
            enter-class="tw-translate-x-full"
            enter-to-class="tw-translate-x-0"
            leave-active-class="tw-transform tw-transition tw-ease-in-out tw-duration-100 sm:tw-duration-200"
            leave-class="tw-translate-x-0"
            leave-to-class="tw-translate-x-full"
          >
            <div :class="`tw-w-screen tw-max-w-${size}`" v-show="isVisible">
              <div class="tw-h-full tw-divide-y tw-divide-gray-200 tw-flex tw-flex-col tw-bg-white tw-shadow-xl">
                <div class="tw-h-0 tw-flex-1 tw-flex tw-flex-col tw-overflow-y-auto" ref="scrollableSection" style="scroll-behavior: smooth;">
                  <header class="tw-px-4 sm:tw-px-6 tw-sticky tw-top-0 tw-bg-white tw-border-b tw-border-gray-150 tw-py-4 sm:tw-py-6 tw-z-50">
                    <div class="tw-flex tw-items-start tw-justify-between tw-space-x-3">
                      <slot name="title">
                        <h2 class="tw-text-lg tw-leading-7 tw-font-normal tw-text-gray-800 tw-mb-0">{{ title }}</h2>
                      </slot>
                      <div class="tw-h-7 tw-flex tw-items-center">
                        <base-icon @click="isVisible = false">
                          <x-icon class="tw-h-6 tw-w-6" />
                        </base-icon>
                      </div>
                    </div>
                  </header>
                  <div class="tw-relative tw-flex-1">
                    <slot />
                  </div>
                </div>
                <slot name="fixed-bottom"></slot>
              </div>
            </div>
          </transition>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import { XIcon } from "@/assets/svgs";

export default {
  components: {
    XIcon,
  },
  props: {
    title: String,
    size: {
      type: String,
      default: "md",
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
    scrollContentToBottom() {
      this.$refs.scrollableSection.scrollTop = this.$refs.scrollableSection.scrollHeight;
    },
  },
  watch: {
    isVisible(newVal) {
      this.$emit(newVal ? "showing" : "hiding");
    },
  },
};
</script>
